import React, { Component } from "react";
import { Link } from "react-router-dom";

class LoginNavbar extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  render() {
    const versionText = process.env.REACT_APP_VERSION ?? "(V3)";
    
    return (
		<div className="loginNavBar">
			<div className="loginContainer">
				<div className="loginLeftContainer">
					<div className="logo">
						<Link to="/home">
							<h3>
								AssetTrak <span>{versionText}</span>
							</h3>
						</Link>
					</div>
				</div>
				<div className="loginRightContainer">
					<ul>
						<li>
							<Link to="/login">Log in</Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
  }
}

export default LoginNavbar;
